import cn from "classnames";
import LinkifyIt from "linkify-it";
import { Fragment, useMemo } from "react";

type LinkifyTextProps = {
  text?: string;
  placeholder?: string;
  className?: string;
  linkClassName?: string;
  wrap?: boolean;
};

const linkify = new LinkifyIt();

export const LinkifyText: React.FC<LinkifyTextProps> = ({
  text,
  placeholder,
  wrap = true,
  className,
  linkClassName,
}) => {
  const content = useMemo(() => {
    if (!text) return <span className="color-secondary">{placeholder}</span>;
    const matches = linkify.match(text);
    if (!matches?.length) return text;
    const parts: React.ReactNode[] = [];
    let last = 0;
    matches.forEach((m, i) => {
      if (m.index > last) parts.push(<Fragment key={`t${i}`}>{text.slice(last, m.index)}</Fragment>);
      parts.push(
        <a key={`a${i}`} href={m.url} target="_blank" className={linkClassName} rel="noreferrer">
          {m.text}
        </a>,
      );
      last = m.lastIndex;
    });
    if (last < text.length) parts.push(<Fragment key="tail">{text.slice(last)}</Fragment>);
    return parts;
  }, [text, placeholder, linkClassName]);

  if (wrap === true)
    return <div className={cn("pre-wrap", className)}>{content}</div>;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{content}</>;
};
